import { Link, useParams } from 'react-router-dom';
import More from '../../../../../../Components/Icons/More';
import { Modal, notification } from 'antd';
import axiosInstance from '../../../../../../Services/axiosCommon';
import { ExclamationCircleFilled } from "@ant-design/icons";
import { GetAccess } from '../../../../../../Components/Utils/roles';

import { useState } from 'react';
import DeleteIcon from '../../../../../../Components/Icons/Delete';
import EditIcon from '../../../../../../Components/Icons/Edit';
import ViewIcon from '../../../../../../Components/Icons/ViewIcon';
import ViewEquipment from '../../Costing/Equipment/ViewEquipment';
import EditEquipment from './EditEquipment';


function ViewMore({ data, getData, id, }){
  const {officeId,projectId} = useParams()
  
  const { confirm } = Modal;
  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);

  const [api, contextHolder] = notification.useNotification();
  const handleDelete = async (id, removevalue) => {
    confirm({
      title: `Do you Want to delete ${removevalue}?`,
      centered: true,
      width: "25%",
      icon: <ExclamationCircleFilled />,
      content: `The ${removevalue} will be removed from the Material`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        axiosInstance
          .delete(`/pro_equipment/delete/${id}`)
          .then((res) => {
            if (res.data.status ==true) {
              api.success({
                message: `Material Item has deleted successfully`,
                description: res?.data?.msg || " ",
                placement: "bottomRight",
              });
              getData();
            } else {
              api.error({
                message: `Material Item has delete failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((error) => {
            api.error({
              message: `Material Item has delete failed`,
              description:
                error?.response?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
          });
      },
      onCancel() {},
    });
  };
  // console.log('====================================');
  // console.log(data);
  // console.log('====================================');

  return (
    <>
      {contextHolder}
      <div className="text-[#344767]  relative dropdown inline-block z-1 group">
        <div className=" cursor-pointer underline-offset-8 text-xs mx-auto font-semibold flex items-center">
          <span className=" w-7 h-7 bg-gray-50 flex flex-col items-center  ml-3 justify-center rounded-full">
            <More />
          </span>
        </div>
        <ul className="dropdown-menuOne  text-[#344767] text-left  rounded-lg absolute -left-[100px] -top-3 overflow-hidden hidden  z-50 shadow-lg ml-7 group-hover:block">
           {/* <li className=' w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              // onClick={() => setOpen(true)}
            >
              <Link className=' text-black hover:text-black' to={`/item/teamandcondition/view/${id}`} state={{ data: data }} >View</Link>
            </span>
          </li> */}
           <li className="w-[100px] bg-black block m-0">
            <span
              className="bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium"
              onClick={() => setViewOpen(true)}
            >
              View
            </span>
          </li>
          {GetAccess(true) && (
            <li className=" w-[100px] bg-black block m-0">
              <span
                className="bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                onClick={() => setOpen(true)}
              >
                Edit
              </span>
            </li>
          )}
          {GetAccess(true) && (
            <li className=" w-[100px] bg-black block m-0">
              <span
                className="bg-white hover:bg-gray-100 cursor-pointer py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                onClick={() => {
                  handleDelete(data.id, data?.description);
                }}
              >
                Delete
              </span>
            </li>
          )}
        </ul>
      </div>
      <EditEquipment
        data={data}
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        getData={getData}
        projectId={projectId}
        id={id}
      />
      <Modal
        open={viewOpen}
        onCancel={() => setViewOpen(false)}
        title={"View Eqipment Item"}
        width="50%"
        centered
        className="my-modal"
        footer={[]}
      >
        <ViewEquipment
          data={data}
          open={viewOpen}
          onCancel={() => setViewOpen(false)}
        />
      </Modal> 
      

{/* <div className='w-full flex justify-between items-center'>
        <div>  <Link
              
             to={`/project/progress/man-power/${officeId}/${projectId}/view/${data?.id}`} state={{data:data}}><ViewIcon color="#048178" /></Link>              
        </div>
        <div>   
        <Link 
              to={`/project/progress/man-power/${officeId}/${projectId}/edit/${data?.id}`} state={{data:data}}><EditIcon color="skyblue" width={"12"} height={"12"} /></Link>             
        </div>
        <div>     
        <a
                
                to='#'
                onClick={() => {
                  handleDelete(id,` ${data?.id||""} ${data?.serial_number||""}`);
                }}
              >
                <DeleteIcon height={"3"} width={"3"} color="lightcoral" />
              </a>                 
        </div>

      </div> */}
    </>
  );
}

export default ViewMore